export default __webpack_public_path__ + "static/media/floor-14.9c5f2aa8.jpg";